import { Observable } from 'rxjs';
import { Alert } from '@app/core/domain';

export interface AlertStateInterface {
  getAlerts(): Observable<Array<Alert>>;
  setAlert(alert: Alert): void;
  removeAlert(id: number): void;
}

export class AlertStateBase implements AlertStateInterface {
  getAlerts(): any { }
  setAlert(alert: Alert): void { }
  removeAlert(id: number): void { }
}
